import { useTranslation } from 'react-i18next';



const NotFoundApp = () => {
	const { t } = useTranslation('global');

	return (
		<div className="lfmt-not-found not-found-app">
			
			<h1>{t('errorHeader')}</h1>

			<p>{t('notfoundMessage')}</p>

		</div>
	);
};

export default NotFoundApp;